<script>
import mixin from "@/pages/inspection_reports/form-sections/mixin";
import Input from "@/pages/components/form/input-only/input.vue";
import MultipleRadios from "@/pages/components/form/input-only/multiple-radios.vue";

export default {
  mixins: [mixin],
  components: {Input, MultipleRadios},
  emits: ['update:form'],
  mounted() {
    for (let name in this.group.values) {
      let config = this.group.values[name];
      this.checkInput(config, config.value);
    }
  },
  methods: {
    handleInput(config, name, value) {
      this.checkInput(config, value);

      this.$emit('update:form', {
        group: this.group.name,
        input: name,
        value: config.value,
      });
    },

    checkInput(config, value) {
      let testValue = config.testValue;
      let margin = 80;
      let difference = Math.abs(testValue - value).toFixed(4);
      config.valid = difference <= margin ? 'OK' : 'Fout';
    }
  }
};
</script>

<template>
  <div class="col-12 col-xl-6">
    <Card class="h-100">
      <h2 class="card-title mb-3">{{ group.title }}</h2>

      <div class="form-group row">
        <div class="col-2 d-none d-md-block">Exentrisch (N)</div>
        <div class="col-12 col-md-8">Aanwijzing (N)</div>
      </div>

      <template v-if="group.values" v-for="(config, name, index) in group.values" :key="name">
        <div class="form-group row mb-2">
          <div class="col-12 col-md-2">{{ config.label }}</div>
          <div class="col-12 col-md-7 col-xxl-8">
            <Input
                :id="group.name + index"
                v-bind="$attrs"
                :name="name"
                v-model="config.value"
                @update:modelValue="handleInput(config, name, $event)"
                required
            />
          </div>
          <div class="col-12 col-md-3 col-xxl-2 mt-2 mt-md-0 d-flex justify-content-end">
            <MultipleRadios
                v-bind="$attrs"
                :name="name"
                :model-value="config.valid ?? 'Fout'"
                :disabled="true"
                :options="[
                  { label: 'OK', value: 'OK' },
                  { label: 'Fout', value: 'Fout' },
                ]"
            />
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>